<template>
  <ul class="iq-timeline" v-if="items" style="position: relative; left: 80px;">
    <li
      v-for="(item, index) in items"
      :key="index"
      :class="{
        selected: item.selected
      }"
      @click="handleClick(item)"
    >
      <small class="mt-1 date" v-html="item.date"></small>
      <div
        class="timeline-dots"
        :class="`border-${item.selected ? 'success' : 'primary'}`"
      ></div>
      <h6 class="mb-1 title" v-html="item.title"></h6>
      <div v-if="item.type === 'visit'" class="akcje-wizyty">
        <button
          type="button"
          class="akcja"
          :disabled="zajete === item.id"
          title="Drukuj opis wizyty"
          @click.stop="drukujWizyte(item)"
        >
          <svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
            <path
              fill="currentColor"
              d="M7 3h10v4H7V3zm12 6H5a2 2 0 0 0-2 2v5h4v4h10v-4h4v-5a2 2 0 0 0-2-2zm-3 9H8v-4h8v4z"
            />
          </svg>
        </button>
        <button
          type="button"
          class="akcja"
          :disabled="zajete === item.id"
          title="Wyślij opis wizyty na e-mail pacjenta"
          @click.stop="wyslijWizyteMailem(item)"
        >
          @
        </button>
      </div>
    </li>

    <b-modal
      id="podglad-maila-wizyty"
      title="Podgląd wiadomości do pacjenta"
      centered
      ok-title="Wyślij"
      cancel-title="Anuluj"
      :ok-disabled="zajete !== null"
      @ok.prevent="potwierdzWyslanie"
    >
      <dl class="podglad">
        <dt>Od</dt>
        <dd>
          <span v-if="podglad.ladujeNadawce" class="text-muted">ustalam…</span>
          <template v-else-if="podglad.nadawca && podglad.nadawca.address">
            {{ podglad.nadawca.name }} &lt;{{ podglad.nadawca.address }}&gt;
          </template>
          <span v-else class="text-muted">
            nie udało się ustalić — sprawdź ustawienia poczty
          </span>
        </dd>

        <dt>Do</dt>
        <dd>{{ pacjentNazwa }} &lt;{{ pacjentEmail }}&gt;</dd>

        <dt>Temat</dt>
        <dd>{{ podgladTemat }}</dd>

        <dt>Załącznik</dt>
        <dd>
          Opis wizyty w formacie PDF
          <template v-if="pacjentMaPesel">
            <br />
            <small>
              Zabezpieczony hasłem — hasłem jest PESEL pacjenta. Hasła nie
              podajemy w treści wiadomości.
            </small>
          </template>
          <template v-else>
            <br />
            <small class="text-danger">
              Pacjent nie ma numeru PESEL — załącznik pójdzie
              <strong>bez zabezpieczenia hasłem</strong>.
            </small>
          </template>
        </dd>
      </dl>
    </b-modal>
  </ul>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import visits from '../services/visits'
export default {
  name: 'TimeLine',
  props: {
    items: { type: Array, default: () => [] }
  },
  data() {
    return {
      // id wizyty, dla której trwa operacja — blokuje podwójne kliknięcie
      zajete: null,
      // stan okna podglądu wiadomości przed wysyłką
      podglad: { item: null, nadawca: null, ladujeNadawce: false }
    }
  },
  computed: {
    ...mapState('Patient', {
      pacjent: (state) => state.patient
    }),
    pacjentEmail() {
      return (this.pacjent && this.pacjent.email) || ''
    },
    pacjentNazwa() {
      if (!this.pacjent) return ''
      return `${this.pacjent.firstName || ''} ${this.pacjent.lastName || ''}`.trim()
    },
    // PDF szyfrujemy PESEL-em — pokazujemy to tylko, gdy PESEL faktycznie jest
    pacjentMaPesel() {
      const p = String((this.pacjent && this.pacjent.pesel) || '').replace(/\D/g, '')
      return p.length === 11
    },
    podgladData() {
      const d = this.podglad.item && this.podglad.item.date
      if (!d) return ''
      const [r, m, dz] = String(d).split('-')
      return dz ? `${dz}.${m}.${r}` : d
    },
    podgladTemat() {
      return this.podgladData
        ? `Opis wizyty z dnia ${this.podgladData}`
        : 'Opis wizyty'
    }
  },
  methods: {
    ...mapActions('Patient', ['setSelectedVisit']),

    // Drukowanie idzie dokładnie tym samym torem co ikona "Podsumowanie"
    // przy wizycie bieżącej: ten sam endpoint i ten sam format PDF,
    // tylko dla wizyty wskazanej na osi czasu.
    async drukujWizyte(item) {
      this.zajete = item.id
      try {
        const patientId = this.$route.params.id
        const { data } = await visits.getPdf(item.id, 'pdf_browser_i', patientId)
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        window.open(url, '_blank')
        setTimeout(() => window.URL.revokeObjectURL(url), 4000)
      } catch (e) {
        this.$swal(
          this.$t('error'),
          this.$t('visit.getPdfSummaryError'),
          'error'
        )
      } finally {
        this.zajete = null
      }
    },

    // Otwiera podgląd wiadomości. Nic jeszcze nie wysyła — wysyłka dopiero
    // po zatwierdzeniu w oknie, bo wiadomości do pacjenta nie da się cofnąć.
    async wyslijWizyteMailem(item) {
      if (!this.pacjentEmail) {
        this.$swal(
          this.$t('error'),
          'Pacjent nie ma zapisanego adresu e-mail — nie ma dokąd wysłać.',
          'error'
        )
        return
      }
      this.podglad = { item, nadawca: null, ladujeNadawce: true }
      this.$bvModal.show('podglad-maila-wizyty')
      try {
        const { data } = await visits.getMailSender()
        this.podglad = { ...this.podglad, nadawca: data, ladujeNadawce: false }
      } catch (e) {
        this.podglad = { ...this.podglad, nadawca: null, ladujeNadawce: false }
      }
    },

    // Właściwa wysyłka — ten sam endpoint co przycisk koperty przy wizycie
    // bieżącej, tylko dla wizyty wskazanej na osi.
    async potwierdzWyslanie() {
      const item = this.podglad.item
      if (!item) return
      this.zajete = item.id
      try {
        const patientId = this.$route.params.id
        await visits.sendEmail(item.id, patientId)
        this.$bvModal.hide('podglad-maila-wizyty')
        this.$swal('Email', 'Email został wysłany', 'success')
      } catch (e) {
        this.$swal(this.$t('error'), this.$t('visit.sendEmailError'), 'error')
      } finally {
        this.zajete = null
      }
    },
    handleClick(item) {
      if (item) {
        this.setSelectedVisit(item)
        const visitBody = document.getElementById(`visit-body`)
        const visit =
          document.querySelector(`#${item.type}-${item.id}`) ||
          document.querySelector(`.${item.type}-${item.id}`)
        if (visit) {
          visitBody.scrollTo({
            top: visit.offsetTop - 80,
            behavior: 'smooth'
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
li {
  width: 150px;
}
.date {
  position: relative;
  right: 100px;
  color: #fff;
}
.title {
  position: relative;
  bottom: 30px;
}
.selected {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
}

/* Małe, dyskretne akcje przy wpisie osi czasu — druk i wysyłka mailem. */
.akcje-wizyty {
  position: absolute;
  right: 6px;
  top: 16px;
  display: flex;
  gap: 4px;
}

.akcja {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  font-size: 12px;
  line-height: 1;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.akcja:hover:not(:disabled) {
  background-color: rgba(255, 255, 255, 0.35);
  border-color: #fff;
}

.akcja:disabled {
  opacity: 0.45;
  cursor: default;
}

.podglad {
  margin: 0;
  color: #212529;
}

.podglad dt {
  font-weight: 600;
  color: #6c757d;
  font-size: 85%;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.podglad dd {
  margin: 0 0 12px;
  word-break: break-word;
}
.iq-timeline {
  margin: 0 0 0 5px;
  padding: 0;
  width: 100%;
  border-left: 3px solid #f2edff;
}

.iq-timeline li {
  margin-left: 15px;
  position: relative;
  padding: 15px 15px 0 5px;
  list-style-type: none;
}

.iq-timeline li .timeline-dots {
  position: absolute;
  top: 20px;
  left: -24px;
  border: 3px solid #089bab;
  border-radius: 90px;
  padding: 5px;
  background: #fff;
}

.iq-timeline li .timeline-dots-fill {
  position: absolute;
  top: 20px;
  left: -23px;
  background: #089bab;
  border-radius: 90px;
  padding: 7px;
}
</style>
